export interface Props {
    children?: any;
    type?: ButtonTypes;
    className?: string;
    onClick?: Function;
    ariaLabel?: string;
    icon?: {
        type: ButtonIconTypes;
        value: any;
        position?: string;
    };
    disabled?: boolean;
    size?: ButtonSizes;
    style?: ButtonStyles;
    styles?: object;
    variant?: ButtonVariants;
    layout?: ButtonLayouts;
    loading?: boolean;
    buttonProps?: any;
    label?: string;
}

export enum ButtonTypes {
    Button = 'button',
    Submit = 'submit',
    Reset = 'reset',
}

export enum ButtonStyles {
    Primary = 'primary',
    Secondary = 'secondary',
    None = 'none',
    TextCTA = 'text-cta',
}

export enum ButtonVariants {
    Primary = 'primary',
    Outline = 'outline',
    Tertiary = 'tertiary',
}

export enum ButtonLayouts {
    Default = 'default',
    Wide = 'wide',
    Block = 'block',
}

export enum ButtonSizes {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

export enum ButtonIconTypes {
    Image = 'image',
    Element = 'element',
}

export enum ButtonIconPositions {
    Before = 'before',
    After = 'after',
}

export interface ListProps extends Props {
    key: string;
}
